module.exports = __webpack_public_path__ + "static/img/2-2.b0744e29.png";